import UploadFileIcon from './component'

export default UploadFileIcon
